import React from "react";
import { helpers } from "services";
import get from "lodash/get";
import useTranslation from "hooks/useTranslation";
import { Avatar } from "components";

const TopClients = ({ items }) => {
  const { tr } = useTranslation();

  return (
    <div className="dashboard-panel h-100-percent">
      <div className="dashboard-panel__head">
        <div>{tr("Топ продажа")}</div>
      </div>
      <div className="dashboard-panel__body">
        {items.map(item => {
          return (
            <div className="d-flex align-items-center justify-content-between mb-10 border-bottom pb-10">
              <div className="d-flex align-items-center">
                <Avatar
                  image={get(item, "file.thumbnails.small.src", get(item, "image_url"))}
                  isProduct={true}
                  isRectangle={true}
                />
                <div className="pl-10 pr-20">
                  <div className="fs-14 fw-700">{helpers.getProductName(item)}</div>
                  <div className="fs-14">
                    {tr("Кол-во продаж")}: {item.quantity}
                  </div>
                </div>
              </div>
              <div className="text-right fw-700 fs-14 ws-no-wrap">
                {helpers.convertToReadable(Number(item.sum))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TopClients;
